import { FC } from 'react';
import { UiText, UiIcon } from '@frontend/znanie-uikit';
import cn from 'classnames';

import { useMediaQueries } from 'hooks/utils/useMediaQueries';

import { Hint } from 'components/common/Hint';

import * as C from './UserScore.const';
import * as T from './UserScore.types';
import css from './UserScore.module.scss';

export const UserScore: FC<T.IUserScore> = (props) => {
  const { isDesktopXl } = useMediaQueries();

  return (
    <Hint
      content={
        <div className={css.hintContainer}>
          <UiIcon name="roz-logo-circle" size={22} />
          <UiText className={css.hintTitle}>Это баллы Знания.</UiText>
          <UiText className={css.hintText}>{C.HINT_TEXT}</UiText>
        </div>
      }
      orientation={isDesktopXl ? 'right' : 'left'}
    >
      <UiText className={cn(css.container, props.className)}>
        {props.score || 0}
        <UiIcon name="roz-logo-circle" size={22} />
      </UiText>
    </Hint>
  );
};
